module.exports = __webpack_public_path__ + "static/passport_vklada-1f28589fb7cab15ff89c4bdda1c51cca.pdf";